/* index.js */

"use strict";
module.exports.ui = {
    component: require("./src/FormsComponent"),
    multiEditComponent: require("./src/FormsMultiEditComponent")
};
module.exports.resolvers = {
    ref: {
        base: require("./src/BaseRefResolver")
    }
};
module.exports.utils= {
    GlueErrorCode: require("./src/util/GlueErrorCode")
};